import styled from 'styled-components';

import { ContainerProps } from './types';

export const ModifierInfoIconButton = styled.button<ContainerProps>`
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Label = styled.span`
  flex: 1;
`;
